;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .directive('coreTableColumnRowDatetime', tableColumnRowDatetime)

  /* @ngInject */
  function tableColumnRowDatetime () {
    return {
      restrict: 'E',
      scope: {
        value: '<',
        simplified: '<'
      },
      templateUrl: '/core/directives/table-columns/table-column-row-datetime/table-column-row-datetime-directive.html?$$REVISION$$'
    }
  }
})()
